import type { IMdInline } from './IMdInline';
import type { MdInlineKind } from './MdInlineKind';

/** Шаблони рядкової розмітки (порядок — пріоритет при однаковій позиції): посилання, колір, виділення, жирний, курсив, код. */
const PATTERNS: Array<[MdInlineKind, RegExp]> = [
  ['code', /`([^`]+)`/],
  ['link', /\[([^\]]+)\]\(([^)\s]+)\)/],
  ['colour', /\{(red|orange|green|blue|purple|grey)\|([^}]+)\}/],
  ['mark', /==([^=]+)==/],
  ['bold', /\*\*(.+?)\*\*/],
  ['italic', /\*(?!\s)([^*]+?)\*/],
];

/**
 * Рядкова розмітка Markdown прототипу (mdToHtml): `код`, [текст](адреса) — зокрема rec:модуль/ід, {колір|текст}, ==виділення==,
 * **жирний**, *курсив*. Повертає дерево елементів без HTML — React показує його безпечно. Чиста функція.
 */
export function mdInline(source: string): IMdInline[] {
  const out: IMdInline[] = [];
  let rest = source;
  while (rest) {
    let best: { kind: MdInlineKind; m: RegExpExecArray } | null = null;
    for (const [kind, re] of PATTERNS) {
      const m = re.exec(rest);
      if (m && (!best || m.index < best.m.index)) best = { kind, m };
    }
    if (!best) { out.push({ kind: 'text', text: rest }); break; }
    const { kind, m } = best;
    if (m.index > 0) out.push({ kind: 'text', text: rest.slice(0, m.index) });
    if (kind === 'code') out.push({ kind, text: m[1] });
    else if (kind === 'link') out.push({ kind, href: m[2], children: mdInline(m[1]!) });
    else if (kind === 'colour') out.push({ kind, colour: m[1], children: mdInline(m[2]!) });
    else out.push({ kind, children: mdInline(m[1]!) });
    rest = rest.slice(m.index + m[0].length);
  }
  return out;
}
